import { render, staticRenderFns } from "./passReject.vue?vue&type=template&id=e4705024&scoped=true"
import script from "./passReject.vue?vue&type=script&lang=js"
export * from "./passReject.vue?vue&type=script&lang=js"
import style0 from "./passReject.vue?vue&type=style&index=0&id=e4705024&prod&scoped=true&lang=css"
import style1 from "./passReject.vue?vue&type=style&index=1&id=e4705024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4705024",
  null
  
)

export default component.exports